import Wrapper from "./Wrapper";

interface Props {
  paths: string[];
}

export default function ArtifactPaths({ paths }: Props) {
  if (!paths.length) {
    return null;
  }

  return (
    <Wrapper title="Artifacts" icon="heroicons/20/solid/cube">
      <ul className="flex flex-row gap-2 flex-wrap">
        {paths.map((path) => (
          <li
            key={path}
            className="bg-white cursor-default inline-block px-3 py-1 shadow-depth-200 rounded-lg"
          >
            <span className="code text-sm text-charcoal-700 truncate max-w-full ...">{path}</span>
          </li>
        ))}
      </ul>
    </Wrapper>
  );
}
